import { Component } from '@angular/core';
import { fadeInOutAnimation } from '../../core/animations';

@Component({
    selector: 'gs-account-layout',
    templateUrl: 'account-layout.component.html',
    animations: [fadeInOutAnimation],
    standalone: false
})
export class AccountLayoutComponent { }
